// extracted by mini-css-extract-plugin
export default {"iconMuteButton":"AmREma9mQZP_ZGwOFiCW","muteButton":"G6R5N33_l_7eb5ERsPnR","muted":"NNUDvdnlqJiPhZrnziff"};